__turbopack_context__.v({
  "className": "indopak_f429779-module__vhYlVa__className",
});
